export default __webpack_public_path__ + "ea-logo.png";